// removed by extract-text-webpack-plugin
module.exports = {"registryFacets":"src-components-RegistryFacets----index-module---registryFacets---zatR9","facet":"src-components-RegistryFacets----index-module---facet---2rUae"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RegistryFacets/index.module.scss
// module id = 72
// module chunks = 104101334113578 114276838955818